import { Tab, TabList, TabPanels, Tabs } from "@carbon/react";
import React from "react";
import { Outlet } from "react-router-dom";

import PageHeader from "src/components/PageHeader.tsx";
import PageStack from "src/components/PageStack/PageStack.tsx";
import { TabType, useTabNavigation } from "src/components/TabbedView/useTabNavigation.ts";
import { useT } from "src/internationalization";

const AlertsPage: React.FC = () => {
  const t = useT();

  const tabs: TabType[] = [
    { label: t("page.tab.not.assigned.name"), code: "notAssigned" },
    { label: t("page.tab.assigned.name"), code: "assigned" },
    { label: t("page.tab.closed.name"), code: "closed" },
    { label: t("page.tab.canceled.name"), code: "canceled" },
  ];

  const { navigateTab, selectedTab } = useTabNavigation({
    tabs,
    pathPrefix: "/alerts",
    getSearch: (searchParams) => {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete("offset");
      newSearchParams.delete("index");
      return newSearchParams.toString();
    },
  });

  const onTabChange = (state: { selectedIndex: number }) => navigateTab(state.selectedIndex);

  return (
    <PageStack>
      <div className="flex items-center">
        <PageHeader className="ml-0">{t("page.alerts.title")}</PageHeader>
      </div>

      <Tabs selectedIndex={selectedTab?.index ?? 0} onChange={onTabChange}>
        {/* Critère  : Valeurs aria-controls invalides
Composant: @carbon/react <Tab> v1.85.0
Cause    : Bug connu Carbon #20988 - non corrigé à ce jour
Statut   : Non conforme - en attente de correctif Carbon */}
        <TabList aria-label="List of tabs">
          {tabs.map((tab) => (
            <Tab key={tab.code}>{tab.label}</Tab>
          ))}
        </TabList>
        <TabPanels>
          <div className="mt-5">
            <Outlet />
          </div>
        </TabPanels>
      </Tabs>
    </PageStack>
  );
};

export default AlertsPage;
